import { connectHook } from 'app/common/components/connect-hook';
import { StringWidget } from './string-widget.js';
import { useStringWidget } from './string-widget-hook.js';

export default connectHook(StringWidget, useStringWidget);
